module.exports = __webpack_public_path__ + "static/tabular-e426f4bbbbff5506d6c07ea614775bf1.png";